import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MoodIcon(props: IconProps) {
    return <Icon {...props} iconKey={"mood"}/>
}
